












































































































import { Component, Ref, Vue } from 'vue-property-decorator';
import { CUSTOMER_LIST_SEARCH } from './customerListSearch';
import CustomerNewButton from '@/components/Customer/CustomerNewButton.vue';
import CustomerShowButton from '@/components/Customer/CustomerShowButton.vue';
import CustomerEditButton from '@/components/Customer/CustomerEditButton.vue';
import CustomerDeleteButton from '@/components/Customer/CustomerDeleteButton.vue';
import SApolloTable from '../UI/Table/SApolloTable.vue';
import { GQL_customerListSearch_customers } from '@/queries/__generated__/customerListSearch';

@Component({
  components: {
    CustomerNewButton,
    CustomerShowButton,
    CustomerEditButton,
    CustomerDeleteButton,
  },
})
export default class CustomerList extends Vue {
  @Ref() private table?: SApolloTable<GQL_customerListSearch_customers>;

  private CUSTOMER_LIST_SEARCH = CUSTOMER_LIST_SEARCH;

  private resetTableResult() {
    this.table?.refetch();
  }
}
